import { useNosIdInfiniteQuery } from '@/hooks/api/base.hooks';
import { api } from '@/portal-api.definition';
import { infiniteQueryOptions } from '@tanstack/react-query';
import { type AccountActivityQuery } from '../-model/queryFilters';

const getAccountActivityQueryOptions = (query: AccountActivityQuery) =>
  infiniteQueryOptions({
    queryKey: ['account-activity', query],
    refetchOnWindowFocus: false,
    initialPageParam: {
      Skip: 0,
      Top: 10,
    },
    queryFn: ({ pageParam }) =>
      api.get('/api/v1/personal-info/activity-logs', {
        search: {
          Top: pageParam.Top,
          Skip: pageParam.Skip,
          Activities: query.activities,
          Devices: query.devices,
          ClientAppIds: query.applications,
          Locations: query.locations,
          Order: query.orders?.[0],
        },
      }),
    getNextPageParam: (lastPage) =>
      lastPage.Count < lastPage.ActiveFilters.Top!
        ? undefined
        : {
            Skip: lastPage.ActiveFilters.Skip! + lastPage.Count,
            Top: lastPage.ActiveFilters.Top!,
          },
  });

export function useGetAccountActivity(query: AccountActivityQuery) {
  return useNosIdInfiniteQuery(getAccountActivityQueryOptions(query));
}
